function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelegations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.602 12C14.461 14.507 11.934 16.25 9 16.25C4.996 16.25 1.75 13.004 1.75 9.00001C1.75 6.06601 3.493 3.53901 6 2.39801",
    stroke: "#C7C5D1",
    style: {
      stroke: "#C7C5D1",
      stroke: "color(display-p3 0.7804 0.7725 0.8196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 9C16.25 4.996 13.004 1.75 9 1.75V9H16.25Z",
    stroke: "#C7C5D1",
    style: {
      stroke: "#C7C5D1",
      stroke: "color(display-p3 0.7804 0.7725 0.8196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegations);
export default __webpack_public_path__ + "static/media/Delegations.e564526f6b81d1059fceaf6a515e3c67.svg";
export { ForwardRef as ReactComponent };